import { useMemo } from 'react';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { IconButton } from '@mui/material';
import ApproveIcon from '@mui/icons-material/TaskTwoTone';
import { getApiErrorMessage } from '@api/getApiError';
import { Document } from '@api/Trinium/Endpoints/Document';
import { usePutDocumentsMutation } from '@api/Trinium/Endpoints/Document/slice';
import { emptyRowSet } from '@components/DataGrid/types';
import { useModalProvider } from '@components/Modals/ModalContext';
import useCurrentTerminal from '@hooks/useCurrentTerminal';

import styles from '../DataGrid.DocumentControl.module.css';

/**
 * Approve Document
 */
export default function ApproveAction() {
	const { number: terminalNumber } = useCurrentTerminal();
	const modalContext = useModalProvider();
	const { queueModalAnnouncement } = modalContext;
	const [putDocuments, { isLoading: isApproving }] = usePutDocumentsMutation();
	const gridApiRef = useGridApiContext();
	const selectedRowsMap = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	const selectedRows = useMemo<Document[]>(() => Array.from(selectedRowsMap.values()) as Document[], [selectedRowsMap]);

	const selectedDocumentIds = useMemo(() => selectedRows.map((row) => row.id), [selectedRows]);

	const handleBtnClick = async () => {
		await putDocuments({
			terminalNumber,
			actionType: {
				action: 'approveDocuments',
				data: {
					docIds: selectedDocumentIds
				}
			}
		})
			.unwrap()
			.then(() => {
				gridApiRef.current.setRowSelectionModel(emptyRowSet);
			})
			.catch((ex: unknown) => {
				queueModalAnnouncement({
					severity: 'error',
					message: getApiErrorMessage(ex)
				});
			});
	};

	return (
		<IconButton
			title='Approve Document'
			onClick={() => {
				void handleBtnClick();
			}}
			loading={isApproving}
			disabled={!selectedDocumentIds.length || isApproving}
			className={styles['icon-btn']}
		>
			<ApproveIcon fontSize='small' />
		</IconButton>
	);
}
